export enum InternalMeterConnectionStatus {
    CONNECTED = 'connected',
    DISCONNECTED = 'disconnected',
    PENDING = 'pending'
}
